export const constants = {
  api: '/api/storeRegisterRoutes',

  navigate: {
    view: '/common/storeregister/log/list',
  },
  moduleName: 'Stock Resister',
};

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};

export const HeaderStandard = [
  [
    { text: 'DATE', style: style1 },
    { text: 'PARTICULAR', style: style1 },
    { text: 'BILL NO./ JOB CARD NO.', style: style1 },
    { text: 'MRR NO.', style: style1 },
    { text: 'OPENING COLUMN', style: style1 },
    { text: 'RECEIPT QTY', style: style1 },
    { text: 'ISSUE QTY', style: style1 },
    { text: 'BALANCE QTY', style: style1 },
    // { text: 'PKT/ROLL/BUNDLE/ BOX QTY', style: style1 },
    { text: 'LOCATION', style: style1 },
    // { text: 'REMARKS', style: style1 },
  ],
];
